@if (!disableHeader) {
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-menu-button (click)="closePopup()"></ion-menu-button>
      </ion-buttons>
      <ion-title style="font-size: 13px;">
        <div class="titleBar adjustedTitleFont">
          {{ 'NUTRITION AND ALLERGIES'  | translate }}
          <!--
          @if (NotificationService.showNotificationBell) {
            <ion-buttons class="notificationbutton" (click)="this.NotificationBellService.openNotificationBell(this.AllNotifications)">
              <div class="bellimgContainer">

                <app-app-icon [icon]="bellIcon" id="bellsize"></app-app-icon>
                @if (this.valideNotification > 0) {
                  <div class="notificationCircle">
                    <p>{{this.valideNotification}}</p>
                  </div>
                }
              </div>
            </ion-buttons>
          }
          -->
        </div>
      </ion-title>
    </ion-toolbar>
  </ion-header>
}

<ion-content class="content-theme-one" style="overflow: auto;">


  @if ((mobile && !settings.navigationSetting) && settings.configuration.uIoptions) {
    <app-undocked-navigation-bar style="position: relative; z-index: 10;"></app-undocked-navigation-bar>
  }

  <!--
  <table class="tables">
    <thead>
      <tr>
        <th>Nutritions</th>
      </tr>
    </thead>
    <tbody>
      @for (nutrition of nutritions; track nutrition) {
        @if(nutrition.isActive) {
          <tr>
            <td>{{ nutrition.name.translations[translationService.getLanguage()] }}</td>
          </tr>
        }
      }
    </tbody>
  </table>

  <table class="tables">
    <thead>
      <tr>
        <th>Allergens</th>
      </tr>
    </thead>
    <tbody>
      @for (allergen of allergens; track allergen) {
        @if(allergen.isActive) {
          <tr>
            <td>{{ allergen.name.translations[translationService.getLanguage()] }}</td>
          </tr>
        }
      }
    </tbody>
  </table>
  -->

  @if (this.nutritions || this.allergens) {

    <div class="topInformation">
      <div class="titleText">

      </div>
      <div class="descriptionText">

      </div>
      <div class="optionsAndSearch">
        <div class="storesDropDownContainer" (click)="$event.stopPropagation()">
          <div class="dropdown" (click)="isOpen = !isOpen">
            
              <span class="storeSelected">
                @if(selectedStore) {
                  {{ selectedStore.displayName }}
                } @else {
                  {{ 'all' }}
                }
              </span>
            
            
            <span class="arrow" [class.open]="isOpen">▾</span>
          </div>

          <ul class="dropdown-menu" [class.open]="isOpen" >
            @if(stores.length > 0) {
              <li (click)="selectStore()">
                {{ 'all' }}
              </li>

              @for (store of stores; track store) {
                <li (click)="selectStore(store)">
                  {{ store.displayName }}
                </li>
              }
            }
            
            
          </ul>   
        </div>
        <div class="searchContainer">

        </div>
        @if(this.settings.configuration.uIoptions?.showNutritionsTable && this.settings.configuration.uIoptions?.showAllergiesTable) {
          <div class="tableSelector">
            <button class="selector" [ngClass]="{'selectedButton': viewNutrition}" (click)="toggleTable(true)" style="border-bottom-left-radius: 7px; border-top-left-radius: 7px;">Nutrition</button>
            <button class="selector" [ngClass]="{'selectedButton': !viewNutrition}" (click)="toggleTable(false)" style="border-bottom-right-radius: 7px; border-top-right-radius: 7px;">Allergens</button>
          </div>
        }
        
      </div>
    </div>

    <div class="tableWrapper">
      @if(viewNutrition) {
        <table class="Table">
          <thead>
            <tr>
              <th #headerCell>
                <div #headerText>
                </div>
              </th>
              @for (nutrition of this.nutritions.nutritions; track nutrition) {
                <th #headerCell class="angled-th">
                  <div #headerText class="angled-text">
                    {{ nutrition.name.translations[translationService.getLanguage()] }}
                  </div>
                </th>
              }
            </tr>
          </thead>
          <tbody class="bodySeperator">
            
            @for (itemId of this.nutritions.itemIds; track itemId; let y = $index) {
              <tr class="seperatorRow" [ngClass]="{'sperator': y != 0}">
                <td (click)="openItemContentDetails('nutrition', itemId)" class="tableData itemNameCell">{{ getIteNutritionName(itemId) }}</td>
                @for (nutrition of this.nutritions.nutritions; track nutrition; let i = $index) {
                  <td class="tableData" [ngClass]="{ 'styledCell': i % 2 === 0 }">{{ getItemNutritionValue(itemId, nutrition) }}</td>
                }
              </tr>
            }
          </tbody>
        </table>
      }


      @if(!viewNutrition) {
        <table class="Table">
          <thead>
            <tr>
              <th #headerCell>
                <div #headerText>
                </div>
              </th>
              @for (allergen of this.allergens.allergens; track allergen) {
                <th #headerCell class="angled-th">
                  <div #headerText class="angled-text">
                    {{ allergen.name.translations[translationService.getLanguage()] }}
                  </div>
                </th>
              }
            </tr>
          </thead>
          <tbody class="bodySeperator">
            
            @for (itemId of this.allergens.itemIds; track itemId; let y = $index) {
              <tr class="seperatorRow" [ngClass]="{'sperator': y != 0}">
                <td (click)="openItemContentDetails('allergen', itemId)" class="tableData itemNameCell">{{ getItemAllergenName(itemId) }}</td>
                @for (allergen of this.allergens.allergens; track allergen; let i = $index) {
                  <td class="tableData" [ngClass]="{ 'styledCell': i % 2 === 0 }">
                    @if(1 == getItemAllergenValue(itemId, allergen)) {
                      <ion-icon style="color: black;" size="small" slot="start" [ios]="'checkmark'" [md]="'checkmark'"></ion-icon>
                    }
                    @if(2 == getItemAllergenValue(itemId, allergen)) {
                      <ion-icon style="color: black;" size="small" slot="start" [ios]="'warning-outline'" [md]="'warning-outline'"></ion-icon>
                    }
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      }
      
    </div>
  }

  <!--
  <table class="tables">
    <thead>
      <tr>
        <th>Allergens</th>
      </tr>
    </thead>
    <tbody>
      @for (allergen of allergens; track allergen) {
        @if(allergen.isActive) {
          <tr>
            <td>{{ allergen.name.translations[translationService.getLanguage()] }}</td>
          </tr>
        }
      }
    </tbody>
  </table>
  -->
  

</ion-content>